export const isResponsiveTypeSpec = (spec) => Object.keys(spec).includes('SM') && Object.keys(spec).includes('LG');
